import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(relativeTime);

function parse(date: unknown): dayjs.Dayjs | null {
  if (date === null || date === undefined || date === '') return null;

  let ts: number;
  if (date instanceof Date) {
    ts = date.getTime();
  } else if (typeof date === 'number') {
    ts = date;
  } else {
    // Normalize PostgreSQL format: "2026-03-25 12:35:03.123456+05:30"
    const s = String(date)
      .replace(' ', 'T')               // space → T separator
      .replace(/(\.\d{3})\d+/, '$1')   // truncate microseconds → milliseconds
      .replace(/([+-]\d{2})$/, '$1:00') // fix bare offset: +05 → +05:00
      .replace(/\+00:00$/, 'Z');       // +00:00 → Z
    ts = new Date(s).getTime();
  }

  if (isNaN(ts)) return null;
  return dayjs(ts);
}

export function formatRelative(date: unknown): string {
  return parse(date)?.fromNow() ?? 'Never';
}

export function formatShortDate(date: unknown): string {
  return parse(date)?.format('MMM D, YYYY') ?? '-';
}

export function formatDateTime(date: unknown): string {
  return parse(date)?.format('MMM D, YYYY h:mm A') ?? '-';
}

export function isOverdue(deadline: unknown): boolean {
  const d = parse(deadline);
  return d ? d.isBefore(dayjs()) : false;
}

export function daysUntil(deadline: unknown): number | null {
  const d = parse(deadline);
  return d ? d.diff(dayjs(), 'day') : null;
}
